import { defineStyleConfig } from "@chakra-ui/react";

export const alertTheme = defineStyleConfig({
	baseStyle: {
		container: {
			minHeight: "33px",
			fontFamily: "forms",
			fontSize: "fontSizes.md",
			borderRadius: "sm",
			display: "flex",
			alignItems: "start",
			py: "8px",
		},
		title: {
			display: "block",
			fontFamily: "paragraphs",
			fontWeight: "medium",
			fontSize: "md",
			color: "neutrals.900",
		},
		description: {
			paddingBottom: "5px",
		},
		icon: {
			width: "12px",
			height: "12px",
			mx: "8px",
			my: "4px",
		},
	},
	variants: {
		info: {
			container: {
				bg: "accent.turquoise.100",
			},
			icon: {
				color: "accent.turquoise.400",
			},
		},
		success: {
			container: {
				bg: "accent.green.100",
			},
			icon: {
				color: "accent.green.400",
			},
		},
		error: {
			container: {
				bg: "accent.red.100",
			},
			icon: {
				color: "accent.red.400",
			},
		},
		warning: {
			container: {
				bg: "accent.orange.100",
			},
			icon: {
				color: "accent.orange.400",
			},
		},
	},
});
